import actions from './actions';

const initialState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
};

export default function receiptReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_RECEIPT_TOOL:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_RECEIPT_TOOL_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_RECEIPT_TOOLS:
    case actions.SEARCH_RECEIPTS:
    case actions.SEARCH_RECEIPT_ISSUED_RECORDS:
    case actions.SEARCH_CREDITS:
    case actions.SEARCH_CREDIT_ALLOWANCE_RECORDS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_RECEIPT_TOOLS_ENDED:
    case actions.SEARCH_RECEIPTS_ENDED:
    case actions.SEARCH_RECEIPT_ISSUED_RECORDS_ENDED:
    case actions.SEARCH_CREDITS_ENDED:
    case actions.SEARCH_CREDIT_ALLOWANCE_RECORDS_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_RECEIPT_TOOL:
    case actions.UPDATE_RECEIPT_IF_INIT:
    case actions.UPDATE_RECEIPT_IF_INVALIDATION_INIT:
    case actions.UPDATE_CREDIT_IF_INVALIDATION_INIT:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_RECEIPT_TOOL_ENDED:
    case actions.UPDATE_RECEIPT_IF_INIT_ENDED:
    case actions.UPDATE_RECEIPT_IF_INVALIDATION_INIT_ENDED:
    case actions.UPDATE_CREDIT_IF_INVALIDATION_INIT_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    default:
      return state;
  }
}
